import { api } from '$app/api';

export function getAssociationsByExternalIds(SKUs) {
  return api
    .post(`/speciality`, {
      eventType: 'GetAssociationsByExternalIdRequest',
      body: {
        externalIds: SKUs,
      },
    })
    .then((res) => res.data);
}

export function listOwners() {
  return api
    .post(`/speciality`, {
      eventType: 'ListOwnersRequest',
      body: {},
    })
    .then((res) => res.data.filter((g) => g.status !== 'DELETED'));
}

export async function updateSpecialityAssociations({ remove, add }) {
  const res = await api.post(`/speciality`, {
    eventType: 'UpdateSpecialityAssociationsRequest',
    body: { remove, add },
  });
  return res;
}

export function listSpecialities() {
  return api
    .post(`/speciality`, {
      eventType: 'ListSpecialitiesRequest',
      body: {},
    })
    .then((res) => res.data);
}
